"use client";
var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/mega-menu/index.tsx
import React23 from "react";
import { IconsConfigProvider } from "@nomadhealth/ds-icons";
import dsTheme2 from "@nomadhealth/ds-theme-nomad-spark";

// src/themes/nomad-spark/theme.css.ts
var theme = "theme_theme__1kbn6bf0";

// src/themes/nomad-spark/breakpoints.ts
import dsTheme from "@nomadhealth/ds-theme-nomad-spark";
var { breakpoints } = dsTheme.base;

// src/themes/nomad-spark/typography.css.ts
var __default__ = { menu1: "typography_getTypographyStyle__1n9nr390", heading3: "typography_getTypographyStyle__1n9nr391", heading6: "typography_getTypographyStyle__1n9nr392", body1: "typography_getTypographyStyle__1n9nr393", body2: "typography_getTypographyStyle__1n9nr394", body3Light: "typography_getTypographyStyle__1n9nr395", body4: "typography_getTypographyStyle__1n9nr396", subtitle1: "typography_getTypographyStyle__1n9nr397", subtitle2: "typography_getTypographyStyle__1n9nr398", button3: "typography_getTypographyStyle__1n9nr399", button4: "typography_getTypographyStyle__1n9nr39a" };
var typography_css_default = __default__;

// src/themes/nomad-spark/common.css.ts
var common_css_exports = {};
__export(common_css_exports, {
  button: () => button,
  card: () => card,
  cardBorder: () => cardBorder,
  hidden: () => hidden,
  link: () => link,
  outlineButton: () => outlineButton,
  primaryButton: () => primaryButton,
  relative: () => relative
});
var button = "common_button__1qi8s8r3";
var card = "common_card__1qi8s8r2";
var cardBorder = "common_cardBorder__1qi8s8r7";
var hidden = "common_hidden__1qi8s8r1";
var link = "common_link__1qi8s8r6";
var outlineButton = "common_outlineButton__1qi8s8r5 typography_getTypographyStyle__1n9nr399 common_button__1qi8s8r3";
var primaryButton = "typography_getTypographyStyle__1n9nr399 common_button__1qi8s8r3";
var relative = "common_relative__1qi8s8r0";

// src/themes/nomad-spark/assets/index.ts
var assets_exports = {};
__export(assets_exports, {
  Logo: () => Logo
});

// src/themes/nomad-spark/assets/logo.tsx
import React from "react";
function Logo() {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "128",
      height: "32",
      viewBox: "0 0 128 32",
      fill: "none",
      "aria-label": "Nomad Logo"
    },
    /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2662_3983)" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M22.9648 28.3762L22.6417 28.2246C21.8528 27.8509 21.5694 27.4863 21.5694 26.3544V15.8387C21.5694 12.3095 19.1016 10.015 15.26 10.015C12.9854 10.015 10.7595 10.9555 8.3946 13.0695V11.8563C8.3946 10.6432 7.81872 9.98608 6.7464 9.98608C6.23009 9.98608 5.82572 10.1179 5.12889 10.3706L1.1844 11.8058C0.426189 12.0784 0.00195312 12.4521 0.00195312 13.0388C0.00195312 13.7067 0.487567 14.0606 1.20606 14.2826C2.17729 14.5859 2.43003 14.9199 2.43003 16.0319V26.3562C2.43003 27.4881 2.1466 27.8527 1.3577 28.2264L1.03456 28.3781C0.388278 28.6813 0.00375838 29.0045 0.00375838 29.6219C0.00375838 30.2393 0.427994 30.7141 1.35951 30.7141H9.46873C10.3984 30.7141 10.8245 30.2393 10.8245 29.6219C10.8245 29.0045 10.44 28.6813 9.79367 28.3781L9.47053 28.2264C8.68163 27.8527 8.39821 27.4881 8.39821 26.3562V15.3838C10.0464 14.2609 11.2397 13.8475 12.4943 13.8475C14.5469 13.8475 15.6084 15.0805 15.6084 17.4671V26.3562C15.6084 27.4881 15.325 27.8527 14.5361 28.2264L14.2129 28.3781C13.5667 28.6813 13.1821 29.0045 13.1821 29.6219C13.1821 30.2393 13.6064 30.7141 14.5379 30.7141H22.6471C23.5768 30.7141 24.0029 30.2393 24.0029 29.6219C24.0029 29.0045 23.6183 28.6813 22.9721 28.3781L22.9648 28.3762Z",
        fill: "currentcolor"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M35.1297 9.98315C29.0821 9.98315 24.5527 14.5125 24.5527 20.5511C24.5527 26.5897 29.1038 31.2202 35.1713 31.2202C41.2387 31.2202 45.7898 26.6692 45.7898 20.5927C45.7898 14.5162 41.2189 9.98496 35.1315 9.98496L35.1297 9.98315ZM39.549 21.3292C39.549 22.5116 39.1843 23.1994 38.1229 24.0804L33.7848 27.6693C33.2487 28.1134 32.8136 28.3065 32.3388 28.3065C31.429 28.3065 30.8314 27.588 30.8314 26.4868V19.9951C30.8314 18.8127 31.1961 18.1249 32.2576 17.2439L36.5956 13.6532C37.1318 13.2092 37.5668 13.016 38.0416 13.016C38.9515 13.016 39.549 13.7345 39.549 14.8357V21.3274V21.3292Z",
        fill: "currentcolor"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M126.795 26.9525C125.824 26.6492 125.571 26.3152 125.571 25.2032V23.5947H125.56V2.62122C125.56 1.40809 124.984 0.750977 123.912 0.750977C123.396 0.750977 122.991 0.88276 122.295 1.1355L118.35 2.57068C117.592 2.84327 117.168 3.21696 117.168 3.80367C117.168 4.47161 117.653 4.82544 118.372 5.04749C119.343 5.35077 119.596 5.68475 119.596 6.79679V10.568C118.2 10.1528 116.917 9.99209 115.774 9.99209C109.504 9.99209 105.146 14.3193 105.146 21.0042C105.146 26.6059 108.656 31.2183 113.387 31.2183C115.662 31.2183 117.605 30.2579 119.607 28.2053V29.3788C119.607 30.5919 120.182 31.249 121.255 31.249C121.771 31.249 122.175 31.1172 122.872 30.8645L126.817 29.4293C127.575 29.1567 127.999 28.783 127.999 28.1963C127.999 27.5284 127.514 27.1745 126.795 26.9525ZM119.605 25.7592C118.26 26.7503 116.996 27.2558 115.853 27.2558C113.203 27.2558 111.414 23.6868 111.414 19.773C111.414 14.9186 113.335 12.5736 116.187 12.5736C117.392 12.5736 118.523 12.8462 119.596 13.5954V24.2139H119.607V25.761L119.605 25.7592Z",
        fill: "currentcolor"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M82.4451 28.3768L82.1219 28.2252C81.333 27.8515 81.0496 27.4868 81.0496 26.3549V15.8393C81.0496 12.2703 78.7334 10.0047 75.0742 10.0047C72.3446 10.0047 69.7053 11.2883 67.7936 13.4636C66.974 11.2901 65.0135 10.0047 62.2424 10.0047C59.7241 10.0047 57.3375 11.0861 55.377 13.1693V11.8551C55.377 10.642 54.8011 9.98486 53.7288 9.98486C53.2125 9.98486 52.8081 10.1166 52.1113 10.3694L48.1668 11.8046C47.4086 12.0772 46.9844 12.4508 46.9844 13.0376C46.9844 13.7055 47.47 14.0593 48.1885 14.2814C49.1597 14.5847 49.4124 14.9186 49.4124 16.0307V26.3549C49.4124 27.4868 49.129 27.8515 48.3401 28.2252L48.017 28.3768C47.3707 28.6801 46.9862 29.0033 46.9862 29.6207C46.9862 30.2381 47.4104 30.7128 48.3419 30.7128H56.462C57.3917 30.7128 57.8177 30.2381 57.8177 29.6207C57.8177 29.0033 57.4332 28.6801 56.7869 28.3768L56.4638 28.2252C55.6749 27.8515 55.3915 27.4868 55.3915 26.3549V17.6392H55.3806V15.657C56.7147 14.3825 58.1012 13.8066 59.5165 13.8066C61.4373 13.8066 62.246 14.8681 62.246 17.4568V26.3549C62.246 27.4868 61.9626 27.8515 61.1737 28.2252L60.8506 28.3768C60.2043 28.6801 59.8198 29.0033 59.8198 29.6207C59.8198 30.2381 60.244 30.7128 61.1755 30.7128H69.2847C70.2144 30.7128 70.6405 30.2381 70.6405 29.6207C70.6405 29.0033 70.256 28.6801 69.6097 28.3768L69.2865 28.2252C68.4976 27.8515 68.2142 27.4868 68.2142 26.3549V15.4638C69.4887 14.3915 70.904 13.8048 72.35 13.8048C74.2618 13.8048 75.0796 14.8663 75.0796 17.4659V26.3549C75.0796 27.4868 74.7962 27.8515 74.0073 28.2252L73.6841 28.3768C73.0379 28.6801 72.6533 29.0033 72.6533 29.6207C72.6533 30.2381 73.0776 30.7128 74.0091 30.7128H82.1291C83.0588 30.7128 83.4849 30.2381 83.4849 29.6207C83.4849 29.0033 83.1004 28.6801 82.4541 28.3768H82.4451Z",
        fill: "currentcolor"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M104.104 26.9417C103.649 26.9417 103.335 27.245 102.748 27.245C102.081 27.245 101.727 26.7486 101.727 25.5156V17.1825C101.727 12.6315 98.2787 9.98315 93.0398 9.98315C87.8009 9.98315 84.1309 12.6116 84.1309 15.8177C84.1309 17.7385 85.3548 19.0744 87.2359 19.0744C88.9852 19.0744 90.1983 17.8613 90.1983 16.3034C90.1983 15.231 89.8553 14.9693 89.8553 14.1894C89.8553 13.007 90.9078 12.2776 92.565 12.2776C94.6176 12.2776 95.7603 13.4709 95.7603 15.4838V18.9517C88.2577 19.9319 84.5966 22.2679 84.5966 26.142C84.5966 29.2164 86.8929 31.2076 90.1893 31.2076C92.5452 31.2076 94.5977 30.1046 96.0546 27.931C96.7316 30.0648 98.1487 31.2184 100.353 31.2184C103.155 31.2184 104.368 29.6406 104.893 28.5286C104.983 28.3264 105.034 28.1242 105.034 27.931C105.034 27.3858 104.68 26.9399 104.104 26.9399V26.9417ZM95.7621 25.7683C94.8108 26.5464 93.8504 26.9002 92.9514 26.9002C91.6263 26.9002 90.7363 25.8983 90.7363 24.5642C90.7363 22.6326 92.6065 21.2371 95.0436 21.2371C95.2765 21.2371 95.5293 21.248 95.7621 21.2877V25.7683Z",
        fill: "currentcolor"
      }
    )),
    /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_2662_3983" }, /* @__PURE__ */ React.createElement("rect", { width: "128", height: "30.498", fill: "white", transform: "translate(0 0.750977)" })))
  );
}

// src/themes/nomad-spark/reset.css.ts
var __default__2 = "reset_reset__1pl0zxb0";
var reset_css_default = __default__2;

// src/utils/link-formatter.ts
var LinkFormatter = class {
  baseUrl;
  setBaseUrl(baseUrl) {
    this.baseUrl = baseUrl;
  }
  formatUrl(url) {
    if (!url || url.startsWith("http")) {
      return url;
    }
    return (this.baseUrl || "") + url;
  }
};
var linkFormatter = new LinkFormatter();

// src/mega-menu/contexts/MenuContext.tsx
import React2, { createContext, useContext, useState } from "react";
var MenuContext = createContext({
  activePanel: void 0,
  setActivePanel: () => {
  }
});
var MegaMenuContextProvider = ({ children }) => {
  const [activePanel, setActivePanel] = useState(void 0);
  return /* @__PURE__ */ React2.createElement(MenuContext.Provider, { value: { activePanel, setActivePanel } }, children);
};
var useMenu = () => {
  const ctx = useContext(MenuContext);
  if (!ctx)
    throw new Error("MegaMenuContext: you must set a value for this context provider");
  return ctx;
};

// src/mega-menu/components/mega-menu-desktop/mega-menu-desktop.tsx
import React13 from "react";

// src/mega-menu/components/mega-menu-desktop/dropdown-nav-set.tsx
import React11, { useCallback as useCallback3, useMemo as useMemo2, useState as useState3 } from "react";

// src/mega-menu/components/mega-menu-desktop/menu-item.tsx
import React4 from "react";
import clsx from "clsx";
import { IconActionExpandSection } from "@nomadhealth/ds-icons";

// src/mega-menu/contexts/MenuItemContext.tsx
import React3, { createContext as createContext2, useCallback, useContext as useContext2, useMemo } from "react";
var MenuItemContext = createContext2({
  isOpen: false,
  openPanel: () => {
  },
  closePanel: () => {
  },
  togglePanel: () => {
  }
});
var MenuItemContextProvider = ({
  panelId,
  children
}) => {
  const { activePanel, setActivePanel } = useMenu();
  const openPanel = useCallback(() => setActivePanel(panelId), [panelId, setActivePanel]);
  const closePanel = useCallback(() => setActivePanel(void 0), [setActivePanel]);
  const togglePanel = useCallback(() => {
    if (activePanel === panelId) {
      closePanel();
    } else {
      openPanel();
    }
  }, [activePanel, closePanel, openPanel, panelId]);
  const isOpen = useMemo(() => activePanel === panelId, [activePanel, panelId]);
  return /* @__PURE__ */ React3.createElement(MenuItemContext.Provider, { value: { openPanel, closePanel, togglePanel, isOpen } }, children);
};
var useMenuItem = () => {
  const ctx = useContext2(MenuItemContext);
  if (!ctx)
    throw new Error("MenuItemContext: you must set a value for this context provider");
  return ctx;
};

// src/mega-menu/components/mega-menu-desktop/menu-item.css.ts
var button2 = "menu-item_button__1ajg2zp0 typography_getTypographyStyle__1n9nr390";
var buttonIcon = "menu-item_buttonIcon__1ajg2zp2";
var buttonIconOpen = "menu-item_buttonIconOpen__1ajg2zp3";
var buttonOpen = "menu-item_buttonOpen__1ajg2zp1";
var divider = "menu-item_divider__1ajg2zp7";
var fullWide = "menu-item_fullWide__1ajg2zp6";
var leftCol = "menu-item_leftCol__1ajg2zp8";
var panel = "menu-item_panel__1ajg2zp5 common_card__1qi8s8r2";
var panelWrapper = "menu-item_panelWrapper__1ajg2zp4";
var rightCol = "menu-item_rightCol__1ajg2zp9";
var rightColContent = "menu-item_rightColContent__1ajg2zpa";
var rightColSubMenu = "menu-item_rightColSubMenu__1ajg2zpb";
var rightColSubMenuLink = "menu-item_rightColSubMenuLink__1ajg2zpc common_link__1qi8s8r6 typography_getTypographyStyle__1n9nr394";

// src/mega-menu/hooks/usePanelOffset.ts
import { useCallback as useCallback2, useEffect, useRef, useState as useState2 } from "react";
function useWindowWidth() {
  const [windowWidth, setWindowWidth] = useState2(0);
  useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };
    handleWindowResize();
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);
  return {
    windowWidth
  };
}
function useComponentDetails({
  ref,
  isOpen
}) {
  const [componentRight, setComponentRight] = useState2(0);
  const getPosition = useCallback2(() => {
    const { current } = ref;
    if (!current) {
      return;
    }
    const { x: leftOffset, width } = current.getBoundingClientRect();
    setComponentRight(leftOffset + width);
  }, [ref]);
  useEffect(() => {
    getPosition();
  }, [getPosition, isOpen]);
  useEffect(() => {
    window.addEventListener("resize", getPosition);
    return () => {
      window.removeEventListener("resize", getPosition);
    };
  }, [getPosition]);
  return {
    componentRight
  };
}
function usePanelOffset({ isOpen }) {
  const [componentOffset, setComponentOffset] = useState2(0);
  const ref = useRef(null);
  const { windowWidth } = useWindowWidth();
  const { componentRight } = useComponentDetails({ ref, isOpen });
  useEffect(() => {
    if (isOpen) {
      let newOffset;
      if (componentRight > windowWidth) {
        newOffset = windowWidth - componentRight;
      } else {
        newOffset = 0;
      }
      if (newOffset !== componentOffset) {
        setComponentOffset(newOffset);
      }
    }
  }, [windowWidth, componentRight, isOpen, componentOffset]);
  return {
    ref,
    componentOffset
  };
}

// src/mega-menu/components/mega-menu-desktop/menu-item.tsx
function MenuItem({ id, children, className }) {
  return /* @__PURE__ */ React4.createElement(MenuItemContextProvider, { panelId: id }, /* @__PURE__ */ React4.createElement("div", { className }, children));
}
MenuItem.Panel = function MenuPanel({ fullWide: fullWide2, children }) {
  const { isOpen } = useMenuItem();
  const { ref, componentOffset } = usePanelOffset({ isOpen });
  return /* @__PURE__ */ React4.createElement(
    "div",
    {
      ref,
      className: clsx(
        panelWrapper,
        isOpen ? "" : common_css_exports.hidden,
        fullWide2 && fullWide
      )
    },
    /* @__PURE__ */ React4.createElement("div", { className: panel, style: { left: componentOffset } }, children)
  );
};
MenuItem.Divider = function MenuPanelDivider() {
  return /* @__PURE__ */ React4.createElement("div", { className: divider });
};
MenuItem.LeftCol = function MenuPanelLeftCol({ children }) {
  return /* @__PURE__ */ React4.createElement("div", { className: clsx(leftCol) }, children);
};
MenuItem.RightCol = function MenuPanelRightCol({ children }) {
  return /* @__PURE__ */ React4.createElement("div", { className: rightCol }, children);
};
MenuItem.RightColContent = function MenuPanelRightColContent({
  showSubMenu,
  children
}) {
  const isHidden = showSubMenu !== void 0;
  return /* @__PURE__ */ React4.createElement("div", { className: clsx(rightColContent, isHidden && common_css_exports.hidden) }, children);
};
MenuItem.RightColSubMenu = function MenuPanelRightColSubMenu({
  links,
  showSubMenu,
  onHover
}) {
  return /* @__PURE__ */ React4.createElement(React4.Fragment, null, links.map((link6) => {
    if (!link6.links || link6.links.length === 0)
      return /* @__PURE__ */ React4.createElement(React4.Fragment, { key: link6.id });
    const isHidden = showSubMenu !== link6.id;
    return /* @__PURE__ */ React4.createElement(
      "div",
      {
        key: link6.id,
        className: clsx(rightColSubMenu, isHidden && common_css_exports.hidden),
        onMouseEnter: () => onHover(link6.id),
        onFocus: () => onHover(link6.id),
        onMouseLeave: () => onHover(),
        onBlur: () => onHover()
      },
      link6.links.map((subLink) => /* @__PURE__ */ React4.createElement("div", { key: subLink.id }, /* @__PURE__ */ React4.createElement(
        "a",
        {
          className: rightColSubMenuLink,
          href: linkFormatter.formatUrl(subLink.url),
          target: subLink.openInNewTab ? "_blank" : void 0
        },
        subLink.label
      )))
    );
  }));
};
MenuItem.Button = function MenuPanelButton({ children }) {
  const { isOpen, openPanel } = useMenuItem();
  return /* @__PURE__ */ React4.createElement(
    "button",
    {
      className: clsx(button2, isOpen && buttonOpen),
      type: "button",
      onMouseEnter: () => openPanel(),
      onFocus: () => openPanel()
    },
    children,
    " ",
    /* @__PURE__ */ React4.createElement("span", { className: clsx(buttonIcon, isOpen && buttonIconOpen) }, /* @__PURE__ */ React4.createElement(IconActionExpandSection, null))
  );
};
MenuItem.Link = function MenuPanelLink() {
  return /* @__PURE__ */ React4.createElement("span", null, "Link");
};

// src/mega-menu/components/mega-menu-desktop/link.tsx
import React5 from "react";
import clsx2 from "clsx";

// src/mega-menu/components/mega-menu-desktop/link.css.ts
var description = "link_description__17wwa3m1 typography_getTypographyStyle__1n9nr395";
var noLink = "link_noLink__17wwa3m2";

// src/mega-menu/components/mega-menu-desktop/link.tsx
function Link({
  className,
  url,
  label: name,
  description: description3,
  openInNewTab
}) {
  if (!url) {
    return /* @__PURE__ */ React5.createElement("span", { className: clsx2(noLink, className) }, name, description3 && /* @__PURE__ */ React5.createElement("span", { className: description }, description3));
  }
  return /* @__PURE__ */ React5.createElement(
    "a",
    {
      className: clsx2(common_css_exports.link, className),
      href: linkFormatter.formatUrl(url),
      rel: "noopener",
      target: openInNewTab ? "_blank" : void 0
    },
    name,
    description3 && /* @__PURE__ */ React5.createElement("span", { className: description }, description3)
  );
}

// src/mega-menu/components/mega-menu-desktop/dropdown-nav-set.css.ts
var bottomLink = "dropdown-nav-set_bottomLink__ecy4gs1 typography_getTypographyStyle__1n9nr397";
var bottomLinksWrapper = "dropdown-nav-set_bottomLinksWrapper__ecy4gs0";

// src/mega-menu/components/common/right-col-content.tsx
import React9 from "react";

// src/mega-menu/components/common/descriptive-card.tsx
import React6 from "react";

// src/mega-menu/components/common/descriptive-card.css.ts
var description2 = "descriptive-card_description__pp8vf3 typography_getTypographyStyle__1n9nr395";
var heading = "descriptive-card_heading__pp8vf0 typography_getTypographyStyle__1n9nr391";
var image = "descriptive-card_image__pp8vf2";
var imageWrapper = "descriptive-card_imageWrapper__pp8vf1";
var link2 = "descriptive-card_link__pp8vf4 typography_getTypographyStyle__1n9nr39a common_link__1qi8s8r6";

// src/mega-menu/components/common/descriptive-card.tsx
function DescriptiveCard({
  heading: heading4,
  image: image2,
  description: description3,
  link: link6
}) {
  return /* @__PURE__ */ React6.createElement("div", null, /* @__PURE__ */ React6.createElement("p", { className: heading }, heading4), /* @__PURE__ */ React6.createElement("div", { className: imageWrapper }, /* @__PURE__ */ React6.createElement("img", { className: image, src: image2.url, alt: heading4, loading: "lazy" })), /* @__PURE__ */ React6.createElement("p", { className: description2 }, description3), /* @__PURE__ */ React6.createElement(
    "a",
    {
      className: link2,
      href: linkFormatter.formatUrl(link6.url),
      target: link6.openInNewTab ? "_blank" : void 0,
      rel: "noopener"
    },
    "Read More"
  ));
}

// src/mega-menu/components/common/link-list.tsx
import React7 from "react";

// src/mega-menu/components/common/link-list.css.ts
var heading2 = "link-list_heading__1bv215l0 typography_getTypographyStyle__1n9nr392";
var link3 = "link-list_link__1bv215l2 typography_getTypographyStyle__1n9nr395 common_link__1qi8s8r6";
var list = "link-list_list__1bv215l1";

// src/mega-menu/components/common/link-list.tsx
function LinkList({ heading: heading4, links }) {
  return /* @__PURE__ */ React7.createElement(React7.Fragment, null, /* @__PURE__ */ React7.createElement("p", { className: heading2 }, heading4), /* @__PURE__ */ React7.createElement("ul", { className: list }, links.map((link6) => /* @__PURE__ */ React7.createElement("li", { key: link6.label }, /* @__PURE__ */ React7.createElement(
    "a",
    {
      className: link3,
      href: linkFormatter.formatUrl(link6.url),
      target: link6.openInNewTab ? "_blank" : void 0,
      rel: "noopener"
    },
    link6.label
  )))));
}

// src/mega-menu/components/common/cards.tsx
import React8 from "react";
import { IconActionGoToDetails } from "@nomadhealth/ds-icons";

// src/mega-menu/components/common/cards.css.ts
var card2 = "cards_card__1yxc1zn3 common_card__1qi8s8r2";
var cardContent = "cards_cardContent__1yxc1zn6";
var cardDescription = "cards_cardDescription__1yxc1zn8 typography_getTypographyStyle__1n9nr395";
var cardImage = "cards_cardImage__1yxc1zn5";
var cardImageWrapper = "cards_cardImageWrapper__1yxc1zn4";
var cardLink = "cards_cardLink__1yxc1zn9 typography_getTypographyStyle__1n9nr39a";
var cardTitle = "cards_cardTitle__1yxc1zn7 typography_getTypographyStyle__1n9nr397";
var heading3 = "cards_heading__1yxc1zn0 typography_getTypographyStyle__1n9nr391";
var link4 = "cards_link__1yxc1zn2 typography_getTypographyStyle__1n9nr39a common_link__1qi8s8r6";

// src/mega-menu/components/common/cards.tsx
function Cards({ heading: heading4, cards, link: link6 }) {
  return /* @__PURE__ */ React8.createElement(React8.Fragment, null, /* @__PURE__ */ React8.createElement("p", { className: heading3 }, heading4), cards.map((card3) => /* @__PURE__ */ React8.createElement(Card, { key: card3.title, ...card3 })), /* @__PURE__ */ React8.createElement(
    "a",
    {
      className: link4,
      href: linkFormatter.formatUrl(link6.url),
      rel: "noopener",
      target: link6.openInNewTab ? "_blank" : void 0
    },
    link6.label
  ));
}
function Card({ image: image2, title: title2, description: description3, link: link6 }) {
  return /* @__PURE__ */ React8.createElement(
    "a",
    {
      href: linkFormatter.formatUrl(link6.url),
      className: card2,
      target: link6.openInNewTab ? "_blank" : void 0,
      rel: "noopener"
    },
    /* @__PURE__ */ React8.createElement("div", { className: cardImageWrapper }, /* @__PURE__ */ React8.createElement("img", { className: cardImage, src: image2.url, alt: "", loading: "lazy" })),
    /* @__PURE__ */ React8.createElement("span", { className: cardContent }, /* @__PURE__ */ React8.createElement("p", { className: cardTitle }, title2), /* @__PURE__ */ React8.createElement("p", { className: cardDescription }, description3), /* @__PURE__ */ React8.createElement("p", { className: cardLink }, "Read More ", /* @__PURE__ */ React8.createElement(IconActionGoToDetails, { color: "textPrimary" })))
  );
}

// src/mega-menu/components/common/right-col-content.tsx
function RightColContent(props) {
  const { type } = props;
  if (type === "descriptive-card") {
    return /* @__PURE__ */ React9.createElement(DescriptiveCard, { ...props });
  }
  if (type === "link-list") {
    return /* @__PURE__ */ React9.createElement(LinkList, { ...props });
  }
  if (type === "cards") {
    return /* @__PURE__ */ React9.createElement(Cards, { ...props });
  }
  return null;
}

// src/mega-menu/components/mega-menu-desktop/nav-item-level-2.tsx
import React10 from "react";
import { IconActionGoToDetails as IconActionGoToDetails2 } from "@nomadhealth/ds-icons";

// src/mega-menu/components/mega-menu-desktop/nav-item-level-2.css.ts
var link5 = "nav-item-level-2_link__1gbxsdp1";
var wrapper = "nav-item-level-2_wrapper__1gbxsdp0 typography_getTypographyStyle__1n9nr393";

// src/mega-menu/components/mega-menu-desktop/nav-item-level-2.tsx
function NavItemLevel2({ onHover, ...props }) {
  return /* @__PURE__ */ React10.createElement(
    "div",
    {
      className: wrapper,
      onMouseEnter: () => onHover && onHover(props.id),
      onFocus: () => onHover && onHover(props.id),
      onMouseLeave: () => onHover && onHover(),
      onBlur: () => onHover && onHover()
    },
    /* @__PURE__ */ React10.createElement(Link, { className: link5, ...props }),
    props.links && /* @__PURE__ */ React10.createElement(IconActionGoToDetails2, null)
  );
}

// src/mega-menu/components/mega-menu-desktop/dropdown-nav-set.tsx
function DropdownNavSet({
  id,
  name,
  links,
  bottomLinks,
  rightCol: rightCol2
}) {
  const [showSubMenu, setShowSubMenu] = useState3();
  const onHover = useCallback3(
    (linkId) => {
      const link6 = links.find((l) => l.id === linkId);
      if (!(link6 == null ? void 0 : link6.links) || link6.links.length === 0) {
        setShowSubMenu(void 0);
        return;
      }
      setShowSubMenu(linkId);
    },
    [setShowSubMenu, links]
  );
  const hasRightSide = useMemo2(() => {
    return links && links.some((link6) => link6.links && link6.links.length > 0) || rightCol2;
  }, [links, rightCol2]);
  return /* @__PURE__ */ React11.createElement(MenuItem, { id, className: common_css_exports.relative }, /* @__PURE__ */ React11.createElement(MenuItem.Button, null, name), /* @__PURE__ */ React11.createElement(MenuItem.Panel, null, /* @__PURE__ */ React11.createElement(MenuItem.LeftCol, null, links.map((link6) => /* @__PURE__ */ React11.createElement(NavItemLevel2, { key: link6.id, ...link6, onHover })), bottomLinks && /* @__PURE__ */ React11.createElement(BottomLinks, { bottomLinks })), hasRightSide && /* @__PURE__ */ React11.createElement(React11.Fragment, null, !showSubMenu && /* @__PURE__ */ React11.createElement(MenuItem.Divider, null), /* @__PURE__ */ React11.createElement(MenuItem.RightCol, null, /* @__PURE__ */ React11.createElement(MenuItem.RightColSubMenu, { links, showSubMenu, onHover }), rightCol2 && /* @__PURE__ */ React11.createElement(MenuItem.RightColContent, { showSubMenu }, /* @__PURE__ */ React11.createElement(RightColContent, { ...rightCol2 }))))));
}
var BottomLinks = ({ bottomLinks }) => {
  if (!bottomLinks || bottomLinks.length === 0)
    return /* @__PURE__ */ React11.createElement(React11.Fragment, null);
  return /* @__PURE__ */ React11.createElement("div", { className: bottomLinksWrapper }, bottomLinks.map((link6) => /* @__PURE__ */ React11.createElement(Link, { key: link6.id, className: bottomLink, ...link6 })));
};

// src/mega-menu/components/mega-menu-desktop/descriptive-nav-set.tsx
import React12, { useMemo as useMemo3 } from "react";
import clsx3 from "clsx";

// src/mega-menu/components/mega-menu-desktop/descriptive-nav-set.css.ts
var linksWrapper = "descriptive-nav-set_linksWrapper__1j2l0d50";
var title = "descriptive-nav-set_title__1j2l0d51 typography_getTypographyStyle__1n9nr391";

// src/mega-menu/components/mega-menu-desktop/descriptive-nav-set.tsx
function DescriptiveNavSet({
  id,
  name,
  column1,
  column2,
  rightCol: rightCol2
}) {
  const showDivider = useMemo3(() => {
    return (column1 && column1.length > 0 || column2 && column2.length > 0) && rightCol2;
  }, [column1, column2, rightCol2]);
  return /* @__PURE__ */ React12.createElement(MenuItem, { id }, /* @__PURE__ */ React12.createElement(MenuItem.Button, null, name), /* @__PURE__ */ React12.createElement(MenuItem.Panel, { fullWide: true }, /* @__PURE__ */ React12.createElement(MenuItem.LeftCol, null, column1.map((group) => /* @__PURE__ */ React12.createElement(ColumnLinks, { key: group.title, ...group }))), column2 && /* @__PURE__ */ React12.createElement(MenuItem.LeftCol, null, column2.map((group) => /* @__PURE__ */ React12.createElement(ColumnLinks, { key: group.title, ...group }))), showDivider && /* @__PURE__ */ React12.createElement(MenuItem.Divider, null), rightCol2 && /* @__PURE__ */ React12.createElement(MenuItem.RightCol, null, /* @__PURE__ */ React12.createElement(MenuItem.RightColContent, null, /* @__PURE__ */ React12.createElement(RightColContent, { ...rightCol2 })))));
}
var ColumnLinks = ({ title: title2, links }) => /* @__PURE__ */ React12.createElement("div", { className: clsx3(linksWrapper) }, /* @__PURE__ */ React12.createElement("div", { className: title }, title2), /* @__PURE__ */ React12.createElement("div", null, links.map((link6) => /* @__PURE__ */ React12.createElement(NavItemLevel2, { key: link6.id, ...link6 }))));

// src/mega-menu/components/mega-menu-desktop/mega-menu-desktop.css.ts
var buttons = "mega-menu-desktop_buttons__1ix4pdt3";
var logo = "mega-menu-desktop_logo__1ix4pdt1";
var navigation = "mega-menu-desktop_navigation__1ix4pdt2";
var outlineButton2 = "common_outlineButton__1qi8s8r5 typography_getTypographyStyle__1n9nr399 common_button__1qi8s8r3";
var outlineButtonGrey = "mega-menu-desktop_outlineButtonGrey__1ix4pdt6 common_outlineButton__1qi8s8r5 typography_getTypographyStyle__1n9nr399 common_button__1qi8s8r3";
var primaryButton2 = "typography_getTypographyStyle__1n9nr399 common_button__1qi8s8r3";
var wrapper2 = "mega-menu-desktop_wrapper__1ix4pdt0";

// src/mega-menu/components/mega-menu-desktop/mega-menu-desktop.tsx
function MegaMenuDesktop({ logo: logo3, nav, facilities, login, register }) {
  const { setActivePanel } = useMenu();
  return /* @__PURE__ */ React13.createElement("div", { className: wrapper2 }, logo3 && /* @__PURE__ */ React13.createElement("div", { className: logo }, /* @__PURE__ */ React13.createElement("a", { href: linkFormatter.formatUrl(logo3.url), rel: "noopener", onClick: logo3.onClick }, /* @__PURE__ */ React13.createElement(assets_exports.Logo, null))), /* @__PURE__ */ React13.createElement("div", { className: navigation, onMouseLeave: () => setActivePanel(void 0) }, nav && nav.map((navSet) => {
    if (navSet.type === "dropdown") {
      return /* @__PURE__ */ React13.createElement(DropdownNavSet, { key: navSet.id, ...navSet });
    }
    return /* @__PURE__ */ React13.createElement(DescriptiveNavSet, { key: navSet.id, ...navSet });
  })), /* @__PURE__ */ React13.createElement("div", { className: buttons }, facilities && /* @__PURE__ */ React13.createElement(
    "a",
    {
      href: linkFormatter.formatUrl(facilities.url),
      rel: "noopener",
      className: outlineButtonGrey,
      onClick: facilities.onClick
    },
    facilities.label
  ), login && /* @__PURE__ */ React13.createElement(
    "a",
    {
      href: linkFormatter.formatUrl(login.url),
      rel: `noopener ${login.noFollow ? "nofollow" : ""}`,
      className: outlineButton2,
      onClick: login.onClick
    },
    login.label
  ), register && /* @__PURE__ */ React13.createElement(
    "a",
    {
      href: linkFormatter.formatUrl(register.url),
      rel: `noopener ${register.noFollow ? "nofollow" : ""}`,
      className: primaryButton2,
      onClick: register.onClick
    },
    register.label
  )));
}

// src/mega-menu/components/mega-menu-mobile/mega-menu-mobile.tsx
import React22, { useCallback as useCallback4, useEffect as useEffect2 } from "react";
import { IconActionShowMenu } from "@nomadhealth/ds-icons";
import clsx10 from "clsx";

// src/mega-menu/components/mega-menu-mobile/mega-menu-mobile.css.ts
var buttons2 = "mega-menu-mobile_buttons__15xfsg32";
var logo2 = "mega-menu-mobile_logo__15xfsg31";
var menu = "mega-menu-mobile_menu__15xfsg35";
var primaryButton3 = "mega-menu-mobile_primaryButton__15xfsg33 typography_getTypographyStyle__1n9nr399 common_button__1qi8s8r3";
var wrapper3 = "mega-menu-mobile_wrapper__15xfsg30";

// src/mega-menu/components/mega-menu-mobile/nav-level-2-dropdown.tsx
import clsx7 from "clsx";
import React19 from "react";

// src/mega-menu/components/mega-menu-mobile/nav-item-divider.tsx
import React14 from "react";

// src/mega-menu/components/mega-menu-mobile/nav-item-divider.css.tsx
var divider2 = "nav-item-divider_divider__1yzif070";

// src/mega-menu/components/mega-menu-mobile/nav-item-divider.tsx
function NavItemDivider() {
  return /* @__PURE__ */ React14.createElement("div", { className: divider2 });
}

// src/mega-menu/components/mega-menu-mobile/nav-item-spacer.tsx
import React15 from "react";
function NavItemSpacer() {
  return /* @__PURE__ */ React15.createElement("div", null);
}

// src/mega-menu/components/mega-menu-mobile/nav-level-2-dropdown.css.ts
var bottomLink2 = "nav-level-2-dropdown_bottomLink__p0eq8i0 typography_getTypographyStyle__1n9nr397 link_menuLinkBase__h04jkw0 common_link__1qi8s8r6";

// src/mega-menu/components/mega-menu-mobile/mega-menu-common.css.ts
var menuLinks = "mega-menu-common_menuLinks__rpx69x0";
var rightColWrapper = "mega-menu-common_rightColWrapper__rpx69x1";

// src/mega-menu/components/mega-menu-mobile/menu-header.tsx
import { IconActionCloseModal, IconActionGoBack } from "@nomadhealth/ds-icons";
import clsx4 from "clsx";
import React16 from "react";

// src/mega-menu/components/mega-menu-mobile/menu-header.css.ts
var menuButton = "menu-header_menuButton__1eyxft51 common_link__1qi8s8r6";
var menuButtonBack = "menu-header_menuButtonBack__1eyxft52";
var menuHeader = "menu-header_menuHeader__1eyxft50";
var spacer = "menu-header_spacer__1eyxft53";

// src/mega-menu/components/mega-menu-mobile/menu-header.tsx
function MenuHeader({ onBackClick, backText, onCloseClick }) {
  return /* @__PURE__ */ React16.createElement("div", { className: menuHeader }, /* @__PURE__ */ React16.createElement(
    "button",
    {
      type: "button",
      className: clsx4(menuButton, menuButtonBack),
      onClick: onBackClick
    },
    /* @__PURE__ */ React16.createElement(IconActionGoBack, { size: "small" }),
    " ",
    /* @__PURE__ */ React16.createElement("p", { className: typography_css_default.body3Light }, backText)
  ), /* @__PURE__ */ React16.createElement("span", { className: spacer }), /* @__PURE__ */ React16.createElement("button", { type: "button", className: menuButton, onClick: onCloseClick }, /* @__PURE__ */ React16.createElement(IconActionCloseModal, null)));
}

// src/mega-menu/components/mega-menu-mobile/link.tsx
import React17 from "react";
import { IconActionGoToNextItems } from "@nomadhealth/ds-icons";
import clsx5 from "clsx";

// src/mega-menu/components/mega-menu-mobile/link.css.tsx
var menuLink = "typography_getTypographyStyle__1n9nr392 link_menuLinkBase__h04jkw0 common_link__1qi8s8r6";
var menuLinkDescription = "link_menuLinkDescription__h04jkw2 typography_getTypographyStyle__1n9nr395";
var outlineButton3 = "common_outlineButton__1qi8s8r5 typography_getTypographyStyle__1n9nr399 common_button__1qi8s8r3 link_buttonCommonOverrides__h04jkw3 typography_getTypographyStyle__1n9nr392";
var primaryButton4 = "typography_getTypographyStyle__1n9nr399 common_button__1qi8s8r3 link_buttonCommonOverrides__h04jkw3 typography_getTypographyStyle__1n9nr392";

// src/mega-menu/components/mega-menu-mobile/link.tsx
function Link2({
  id,
  label,
  url,
  openInNewTab,
  links,
  className = menuLink,
  description: description3
}) {
  const { setActivePanel } = useMenu();
  const LinkLabel = () => /* @__PURE__ */ React17.createElement("span", null, label, description3 && /* @__PURE__ */ React17.createElement("p", { className: menuLinkDescription }, description3));
  const classNameToUse = clsx5(common_css_exports.link, className);
  if (links && links.length > 0) {
    return /* @__PURE__ */ React17.createElement("button", { type: "button", className: classNameToUse, onClick: () => setActivePanel(id) }, /* @__PURE__ */ React17.createElement(LinkLabel, null), /* @__PURE__ */ React17.createElement(IconActionGoToNextItems, null));
  }
  return /* @__PURE__ */ React17.createElement(
    "a",
    {
      className: classNameToUse,
      href: url,
      rel: "noopener",
      target: openInNewTab ? "_blank" : void 0
    },
    /* @__PURE__ */ React17.createElement(LinkLabel, null)
  );
}

// src/mega-menu/components/mega-menu-mobile/nav-level-3-dropdown.tsx
import clsx6 from "clsx";
import React18 from "react";
function NavLevel3Dropdown({
  id,
  links,
  parentId,
  parentName,
  closeMenu
}) {
  const { activePanel, setActivePanel } = useMenu();
  return /* @__PURE__ */ React18.createElement("div", { className: clsx6(activePanel !== id && common_css_exports.hidden) }, /* @__PURE__ */ React18.createElement(
    MenuHeader,
    {
      onBackClick: () => setActivePanel(parentId),
      backText: `Back to ${parentName}`,
      onCloseClick: closeMenu
    }
  ), /* @__PURE__ */ React18.createElement("div", { className: menuLinks }, links.map((subLink) => /* @__PURE__ */ React18.createElement(Link2, { key: `${subLink.id}-link`, ...subLink }))));
}

// src/mega-menu/components/mega-menu-mobile/nav-level-2-dropdown.tsx
function NavLevel2Dropdown({ navSet, closeMenu }) {
  const { activePanel, setActivePanel } = useMenu();
  return /* @__PURE__ */ React19.createElement(React19.Fragment, null, /* @__PURE__ */ React19.createElement("div", { className: clsx7(activePanel !== navSet.id && common_css_exports.hidden) }, /* @__PURE__ */ React19.createElement(
    MenuHeader,
    {
      onBackClick: () => setActivePanel(void 0),
      backText: "Back to main",
      onCloseClick: closeMenu
    }
  ), /* @__PURE__ */ React19.createElement("div", { className: menuLinks }, navSet.links.map((subLink) => /* @__PURE__ */ React19.createElement(Link2, { key: subLink.id, ...subLink })), navSet.bottomLinks && /* @__PURE__ */ React19.createElement(React19.Fragment, null, /* @__PURE__ */ React19.createElement(NavItemSpacer, null), navSet.bottomLinks.map((subLink) => /* @__PURE__ */ React19.createElement(Link2, { key: subLink.id, className: bottomLink2, ...subLink }))), navSet.rightCol && /* @__PURE__ */ React19.createElement(React19.Fragment, null, /* @__PURE__ */ React19.createElement(NavItemSpacer, null), /* @__PURE__ */ React19.createElement(NavItemDivider, null), /* @__PURE__ */ React19.createElement(NavItemSpacer, null), /* @__PURE__ */ React19.createElement("div", { className: rightColWrapper }, /* @__PURE__ */ React19.createElement(RightColContent, { ...navSet.rightCol }))), /* @__PURE__ */ React19.createElement(NavItemSpacer, null))), navSet.links.map((subLink) => {
    if (!subLink.links || subLink.links.length === 0) {
      return null;
    }
    return /* @__PURE__ */ React19.createElement(
      NavLevel3Dropdown,
      {
        key: `${subLink.id}-level3`,
        id: subLink.id,
        links: subLink.links,
        parentId: navSet.id,
        parentName: navSet.name,
        closeMenu
      }
    );
    return null;
  }));
}

// src/mega-menu/components/mega-menu-mobile/nav-level-2-descriptive.tsx
import clsx8 from "clsx";
import React20 from "react";

// src/mega-menu/components/mega-menu-mobile/nav-level-2-descriptive.css.ts
var columnGroup = "nav-level-2-descriptive_columnGroup__vsagk30";
var columnGroupTitle = "nav-level-2-descriptive_columnGroupTitle__vsagk31 typography_getTypographyStyle__1n9nr391";

// src/mega-menu/components/mega-menu-mobile/nav-level-2-descriptive.tsx
function NavLevel2Descriptive({ navSet, closeMenu }) {
  const { activePanel, setActivePanel } = useMenu();
  return /* @__PURE__ */ React20.createElement(React20.Fragment, null, /* @__PURE__ */ React20.createElement("div", { className: clsx8(activePanel !== navSet.id && common_css_exports.hidden) }, /* @__PURE__ */ React20.createElement(
    MenuHeader,
    {
      onBackClick: () => setActivePanel(void 0),
      backText: "Back to main",
      onCloseClick: closeMenu
    }
  ), /* @__PURE__ */ React20.createElement("div", { className: menuLinks }, navSet.column1.map((colGroup) => /* @__PURE__ */ React20.createElement(NavLevel2DescriptiveColGroup, { key: colGroup.title, colGroup })), navSet.column2 && navSet.column2.map((colGroup) => /* @__PURE__ */ React20.createElement(NavLevel2DescriptiveColGroup, { key: colGroup.title, colGroup })), navSet.rightCol && /* @__PURE__ */ React20.createElement(React20.Fragment, null, /* @__PURE__ */ React20.createElement(NavItemSpacer, null), /* @__PURE__ */ React20.createElement(NavItemDivider, null), /* @__PURE__ */ React20.createElement(NavItemSpacer, null), /* @__PURE__ */ React20.createElement("div", { className: rightColWrapper }, /* @__PURE__ */ React20.createElement(RightColContent, { ...navSet.rightCol }))), /* @__PURE__ */ React20.createElement(NavItemSpacer, null))));
}
var NavLevel2DescriptiveColGroup = ({ colGroup }) => /* @__PURE__ */ React20.createElement("div", { key: colGroup.title, className: columnGroup }, /* @__PURE__ */ React20.createElement("p", { className: columnGroupTitle }, colGroup.title), /* @__PURE__ */ React20.createElement("div", { className: menuLinks }, colGroup.links.map((subLink) => /* @__PURE__ */ React20.createElement(Link2, { key: subLink.id, ...subLink }))));

// src/mega-menu/components/mega-menu-mobile/nav-level-1.tsx
import clsx9 from "clsx";
import React21 from "react";
import { IconActionGoToNextItems as IconActionGoToNextItems2 } from "@nomadhealth/ds-icons";

// src/mega-menu/components/mega-menu-mobile/nav-level-1.css.ts
var button3 = "nav-level-1_button__1h7kr840";

// src/mega-menu/components/mega-menu-mobile/nav-level-1.tsx
function NavLevel1({ nav, facilities, login, register, closeMenu }) {
  const { activePanel, setActivePanel } = useMenu();
  return /* @__PURE__ */ React21.createElement("div", { className: clsx9(activePanel && common_css_exports.hidden) }, /* @__PURE__ */ React21.createElement(MenuHeader, { onBackClick: closeMenu, backText: "Back", onCloseClick: closeMenu }), /* @__PURE__ */ React21.createElement("div", { className: menuLinks }, nav && nav.map(({ id, name }) => /* @__PURE__ */ React21.createElement(
    "button",
    {
      type: "button",
      key: id,
      className: menuLink,
      onClick: () => setActivePanel(id)
    },
    name,
    /* @__PURE__ */ React21.createElement(IconActionGoToNextItems2, null)
  )), facilities && /* @__PURE__ */ React21.createElement(React21.Fragment, null, /* @__PURE__ */ React21.createElement(NavItemSpacer, null), /* @__PURE__ */ React21.createElement(
    "a",
    {
      href: linkFormatter.formatUrl(facilities.url),
      className: menuLink,
      onClick: facilities.onClick
    },
    facilities.label
  )), login || register ? /* @__PURE__ */ React21.createElement(NavItemSpacer, null) : null, login && /* @__PURE__ */ React21.createElement(
    "a",
    {
      href: linkFormatter.formatUrl(login.url),
      rel: `noopener ${login.noFollow ? "nofollow" : ""}`,
      className: clsx9(outlineButton3, button3),
      onClick: login.onClick
    },
    login.label
  ), register && /* @__PURE__ */ React21.createElement(
    "a",
    {
      href: linkFormatter.formatUrl(register.url),
      rel: `noopener ${register.noFollow ? "nofollow" : ""}`,
      className: clsx9(primaryButton4, button3),
      onClick: register.onClick
    },
    register.label
  )));
}

// src/mega-menu/components/mega-menu-mobile/mega-menu-mobile.tsx
function MegaMenuMobile(props) {
  const { logo: logo3, nav, register } = props;
  const [menuOpen, setMenuOpen] = React22.useState(false);
  const { setActivePanel } = useMenu();
  const closeMenu = useCallback4(() => {
    setActivePanel(void 0);
    setMenuOpen(false);
  }, [setActivePanel, setMenuOpen]);
  useEffect2(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);
  useEffect2(() => {
    window.addEventListener("resize", closeMenu);
    return () => {
      window.removeEventListener("resize", closeMenu);
    };
  }, [closeMenu]);
  return /* @__PURE__ */ React22.createElement("div", { className: wrapper3 }, logo3 && /* @__PURE__ */ React22.createElement("div", { className: logo2 }, /* @__PURE__ */ React22.createElement("a", { href: linkFormatter.formatUrl(logo3.url), rel: "noopener", onClick: logo3.onClick }, /* @__PURE__ */ React22.createElement(assets_exports.Logo, null))), /* @__PURE__ */ React22.createElement("div", { className: buttons2 }, register && /* @__PURE__ */ React22.createElement(
    "a",
    {
      href: linkFormatter.formatUrl(register.url),
      rel: "noopener",
      className: primaryButton3,
      onClick: register.onClick
    },
    register.label
  ), /* @__PURE__ */ React22.createElement("button", { type: "button", className: common_css_exports.link, onClick: () => setMenuOpen(true) }, /* @__PURE__ */ React22.createElement(IconActionShowMenu, { size: "large" }))), /* @__PURE__ */ React22.createElement("div", { className: clsx10([menu, !menuOpen && common_css_exports.hidden]) }, /* @__PURE__ */ React22.createElement(NavLevel1, { ...props, closeMenu }), nav && nav.map((navSet) => {
    if (navSet.type === "dropdown") {
      return /* @__PURE__ */ React22.createElement(
        NavLevel2Dropdown,
        {
          key: `${navSet.id}-level2`,
          navSet,
          closeMenu
        }
      );
    }
    if (navSet.type === "descriptive") {
      return /* @__PURE__ */ React22.createElement(
        NavLevel2Descriptive,
        {
          key: `${navSet.id}-level2`,
          navSet,
          closeMenu
        }
      );
    }
    return null;
  })));
}

// src/mega-menu/index.tsx
function MegaMenu(data) {
  linkFormatter.setBaseUrl(data.baseDomain);
  return /* @__PURE__ */ React23.createElement("div", { className: reset_css_default }, /* @__PURE__ */ React23.createElement("nav", { className: theme }, /* @__PURE__ */ React23.createElement(IconsConfigProvider, { colors: dsTheme2.base.color }, /* @__PURE__ */ React23.createElement(MegaMenuContextProvider, null, /* @__PURE__ */ React23.createElement(MegaMenuDesktop, { ...data }), /* @__PURE__ */ React23.createElement(MegaMenuMobile, { ...data })))));
}

// src/mega-menu/NAV_DATA.ts
var ASSETS_DOMAIN = "https://dsassets.nomadhealth.com";
var asset = (path) => `${ASSETS_DOMAIN}${path}`;
var NAV_DATA = [
  {
    id: "travel-jobs",
    type: "dropdown",
    name: "Travel Jobs",
    links: [
      {
        id: "travel-jobs-browse-travel-nurse-jobs",
        label: "Browse Travel Nurse Jobs",
        links: [
          {
            id: "travel-jobs-browse-travel-nurse-jobs-all",
            label: "All Travel Nurse Jobs",
            url: "/healthcare-jobs/nurse/travel-nurse"
          },
          {
            id: "travel-jobs-browse-travel-nurse-jobs-cardiac-icu",
            label: "Cardiac ICU",
            url: "/healthcare-jobs/nurse/travel-nurse/cardiac-icu"
          },
          {
            id: "travel-jobs-browse-travel-nurse-jobs-cath-lab",
            label: "Cath Lab",
            url: "/healthcare-jobs/nurse/travel-nurse/cath-lab"
          },
          {
            id: "travel-jobs-browse-travel-nurse-jobs-critical-care",
            label: "Critical Care",
            url: "/healthcare-jobs/nurse/travel-nurse/critical-care"
          },
          {
            id: "travel-jobs-browse-travel-nurse-jobs-emergency-room",
            label: "Emergency Room",
            url: "/healthcare-jobs/nurse/travel-nurse/emergency-room"
          },
          {
            id: "travel-jobs-browse-travel-nurse-jobs-icu",
            label: "ICU",
            url: "/healthcare-jobs/nurse/travel-nurse/icu"
          },
          {
            id: "travel-jobs-browse-travel-nurse-jobs-labor-and-delivery",
            label: "Labor and Delivery",
            url: "/healthcare-jobs/nurse/travel-nurse/labor-and-delivery"
          },
          {
            id: "travel-jobs-browse-travel-nurse-jobs-long-term-care",
            label: "Long-Term Care",
            url: "/healthcare-jobs/nurse/travel-nurse/long-term-care"
          },
          {
            id: "travel-jobs-browse-travel-nurse-jobs-med-surg",
            label: "Med-Surg",
            url: "/healthcare-jobs/nurse/travel-nurse/medical-surgical"
          },
          {
            id: "travel-jobs-browse-travel-nurse-jobs-micu",
            label: "MICU",
            url: "/healthcare-jobs/nurse/travel-nurse/micu"
          },
          {
            id: "travel-jobs-browse-travel-nurse-jobs-oncology",
            label: "Oncology",
            url: "/healthcare-jobs/nurse/travel-nurse/oncology"
          },
          {
            id: "travel-jobs-browse-travel-nurse-jobs-operating-room",
            label: "Operating Room",
            url: "/healthcare-jobs/nurse/travel-nurse/operating-room"
          },
          {
            id: "travel-jobs-browse-travel-nurse-jobs-pediatric-icu",
            label: "Pediatric ICU",
            url: "/healthcare-jobs/nurse/travel-nurse/picu"
          },
          {
            id: "travel-jobs-browse-travel-nurse-jobs-psych",
            label: "Psych",
            url: "/healthcare-jobs/nurse/travel-nurse/psychiatry"
          },
          {
            id: "travel-jobs-browse-travel-nurse-jobs-rehabilitation",
            label: "Rehabilitation",
            url: "/healthcare-jobs/nurse/travel-nurse/rehabilitation"
          },
          {
            id: "travel-jobs-browse-travel-nurse-jobs-step-down",
            label: "Step-Down",
            url: "/healthcare-jobs/nurse/travel-nurse/step-down"
          },
          {
            id: "travel-jobs-browse-travel-nurse-jobs-telemetry",
            label: "Telemetry",
            url: "/healthcare-jobs/nurse/travel-nurse/telemetry"
          }
        ]
      },
      {
        id: "travel-jobs-browse-travel-allied-jobs",
        label: "Browse Travel Alllied Jobs",
        links: [
          {
            id: "travel-jobs-browse-travel-allied-jobs-all",
            label: "All Travel Allied Jobs",
            url: "/healthcare-jobs/allied/travel-allied"
          },
          {
            id: "travel-jobs-browse-travel-allied-jobs-cath-lab-tech",
            label: "Cath Lab Tech",
            url: "/healthcare-jobs/allied/travel-allied/cath-lab-tech"
          },
          {
            id: "travel-jobs-browse-travel-allied-jobs-laboratory",
            label: "Laboratory",
            url: "/healthcare-jobs/allied/travel-allied/lab-tech"
          },
          {
            id: "travel-jobs-browse-travel-allied-jobs-occupational-therapist",
            label: "Occupational Therapist",
            url: "/healthcare-jobs/allied/travel-allied/occupational-therapist"
          },
          {
            id: "travel-jobs-browse-travel-allied-jobs-physical-therapist",
            label: "Physical Therapist",
            url: "/healthcare-jobs/allied/travel-allied/physical-therapist"
          },
          {
            id: "travel-jobs-browse-travel-allied-jobs-radiology-tech",
            label: "Radiology Tech",
            url: "/healthcare-jobs/allied/travel-allied/radiology-tech"
          },
          {
            id: "travel-jobs-browse-travel-allied-jobs-respiratory-therapist",
            label: "Respiratory Therapist",
            url: "/healthcare-jobs/allied/travel-allied/respiratory-therapist"
          },
          {
            id: "travel-jobs-browse-travel-allied-jobs-speech-language-pathologist",
            label: "Speech Language Pathologist",
            url: "/healthcare-jobs/allied/travel-allied/speech-language-pathologist"
          },
          {
            id: "travel-jobs-browse-travel-allied-jobs-surgical-tech",
            label: "Surgical Tech",
            url: "/healthcare-jobs/allied/travel-allied/surgical-technologist"
          },
          {
            id: "travel-jobs-browse-travel-allied-jobs-ultrasound-tech",
            label: "Ultrasound Tech",
            url: "/healthcare-jobs/allied/travel-allied/ultrasound-technologist"
          }
        ]
      },
      {
        id: "travel-jobs-see-all-jobs",
        label: "See All Jobs",
        url: "/healthcare-jobs"
      }
    ],
    rightCol: {
      type: "descriptive-card",
      heading: "Salary Data",
      description: "Discover the latest salary data trends for travel nurses and travel allied health professionals.",
      image: {
        url: asset("/components/mega-menu/Salary-Data.jpg")
      },
      link: {
        url: "/faqs/salary-data"
      }
    }
  },
  {
    id: "travel-allied",
    type: "dropdown",
    name: "Travel Allied",
    links: [
      {
        id: "travel-allied-learn-about-allied-travel",
        label: "Learn About Travel Allied",
        url: "/allied/travel-allied"
      },
      {
        id: "travel-allied-lab-tech",
        label: "Lab Tech",
        url: "/allied/travel-allied/lab-tech"
      },
      {
        id: "travel-allied-radiology-tech",
        label: "Radiology Tech",
        url: "/allied/travel-allied/radiology-tech"
      },
      {
        id: "travel-allied-surgical-tech",
        label: "Surgical Tech",
        url: "/allied/travel-allied/surgical-tech"
      },
      {
        id: "travel-allied-ultrasound-tech",
        label: "Ultrasound Tech",
        url: "/allied/travel-allied/ultrasound-tech"
      }
    ],
    rightCol: {
      type: "descriptive-card",
      heading: "Travel Allied FAQs",
      image: {
        url: asset("/components/mega-menu/Travel-Allied-FAQs.jpg")
      },
      description: `Read answers to common questions about allied health travel with Nomad Health.`,
      link: {
        url: "/faqs/travel-allied"
      }
    }
  },
  {
    id: "travel-nurse",
    type: "dropdown",
    name: "Travel Nurse",
    links: [
      {
        id: "travel-nurse-learn-about-travel-nursing",
        label: "Learn About Travel Nursing",
        url: "/nurse/travel-nurse"
      },
      {
        id: "travel-nurse-cardiac-icu",
        label: "Cardiac ICU",
        url: "/nurse/travel-nurse/cardiac-icu"
      },
      {
        id: "travel-nurse-cath-lab",
        label: "Cath Lab",
        url: "/nurse/travel-nurse/cath-lab"
      },
      {
        id: "travel-nurse-critical-care",
        label: "Critical Care",
        url: "/nurse/travel-nurse/critical-care"
      },
      {
        id: "travel-nurse-emergency-room",
        label: "Emergency Room",
        url: "/nurse/travel-nurse/emergency-room"
      },
      {
        id: "travel-nurse-icu",
        label: "ICU",
        url: "/nurse/travel-nurse/icu"
      },
      {
        id: "travel-nurse-labor-and-delivery",
        label: "Labor and Delivery",
        url: "/nurse/travel-nurse/labor-and-delivery"
      },
      {
        id: "travel-nurse-long-term-care",
        label: "Long-Term Care",
        url: "/nurse/travel-nurse/long-term-care"
      },
      {
        id: "travel-nurse-med-surg",
        label: "Med-Surg",
        url: "/nurse/travel-nurse/medical-surgical"
      },
      {
        id: "travel-nurse-micu",
        label: "MICU",
        url: "/nurse/travel-nurse/micu"
      },
      {
        id: "travel-nurse-oncology",
        label: "Oncology",
        url: "/nurse/travel-nurse/oncology"
      },
      {
        id: "travel-nurse-operating-room",
        label: "Operating Room",
        url: "/nurse/travel-nurse/operating-room"
      },
      {
        id: "travel-nurse-pediatric-icu",
        label: "Pediatric ICU",
        url: "/nurse/travel-nurse/picu"
      },
      {
        id: "travel-nurse-psych",
        label: "Psych",
        url: "/nurse/travel-nurse/psychiatry"
      },
      {
        id: "travel-nurse-rehabilitation",
        label: "Rehabilitation",
        url: "/nurse/travel-nurse/rehabilitation"
      },
      {
        id: "travel-nurse-step-down",
        label: "Step-Down",
        url: "/nurse/travel-nurse/step-down"
      },
      {
        id: "travel-nurse-telemetry",
        label: "Telemetry",
        url: "/nurse/travel-nurse/telemetry"
      }
    ],
    rightCol: {
      type: "descriptive-card",
      heading: "Travel Nurse FAQs",
      image: {
        url: asset("/components/mega-menu/Travel-Nurse-FAQs.jpg")
      },
      description: `Read answers to common questions about travel nursing with Nomad Health.`,
      link: {
        url: "/faqs/travel-nurse"
      }
    }
  },
  {
    id: "faqs",
    type: "descriptive",
    name: "FAQs",
    column1: [
      {
        title: "Connect",
        links: [
          {
            id: "faqs-connect-contact-us",
            label: "Contact Us",
            url: "/contact-us",
            description: "Get in touch"
          },
          {
            id: "faqs-connect-support",
            label: "Support",
            url: "https://nomadhealth.zendesk.com/hc/en-us",
            description: "Get the help you need",
            openInNewTab: true
          }
        ]
      },
      {
        title: "Benefits",
        links: [
          {
            id: "faqs-benefits-nomad-health",
            label: "Nomad Health",
            url: "/faqs/nomad-health",
            description: "Find information on health insurance options, benefits, and more"
          },
          {
            id: "faqs-benefits-referral-bonus",
            label: "Referral Bonus",
            url: "/referrals",
            description: "Refer a friend and you can both earn"
          }
        ]
      }
    ],
    column2: [
      {
        title: "Learn",
        links: [
          {
            id: "nomad-blog",
            label: "Nomad Blog",
            url: "/blog",
            description: "Expert tips, stories & support for traveling clinicians"
          },
          {
            id: "faqs-learn-get-started",
            label: "Get Started",
            url: "/faqs/getting-started",
            description: "Discover helpful resources for new travelers"
          },
          {
            id: "faqs-learn-liceses-certifications",
            label: "Licenses and Certifications",
            url: "/faqs/licensure-and-certifications",
            description: "Make sure you\u2019re up to date with your qualifications"
          },
          {
            id: "faqs-learn-how-to-guides",
            label: "How-To Guides",
            url: "/faqs/how-to-guides",
            description: "Explore our collection of how-to guides"
          },
          {
            id: "faqs-learn-salary-data",
            label: "Salary Data",
            url: "/faqs/salary-data",
            description: "Read industry trends to see how your salary stacks up"
          },
          {
            id: "faqs-learn-covid-19",
            label: "COVID-19",
            url: "/faqs/covid-19",
            description: "Stay informed and learn how we\u2019re supporting our travelers"
          },
          {
            id: "faqs-learn-travel-nurse-faqs",
            label: "Travel Nurse FAQs",
            url: "/faqs/travel-nurse"
          },
          {
            id: "faqs-learn-travel-allied-faqs",
            label: "Travel Allied FAQs",
            url: "/faqs/travel-allied"
          },
          {
            id: "faqs-learn-travel-ultrasound-tech-faqs",
            label: "Travel Ultrasound Tech FAQs",
            url: "/faqs/travel-allied/ultrasound-tech"
          },
          {
            id: "faqs-learn-travel-surgical-tech-faqs",
            label: "Travel Surgical Tech FAQs",
            url: "/faqs/travel-allied/surgical-tech"
          },
          {
            id: "faqs-learn-travel-laboratory-faqs",
            label: "Travel Laboratory FAQs",
            url: "/faqs/travel-allied/laboratory"
          },
          {
            id: "faqs-learn-travel-radiology-tech-faqs",
            label: "Travel Radiology Tech FAQs",
            url: "/faqs/travel-allied/radiology-tech"
          }
        ]
      }
    ],
    rightCol: {
      type: "descriptive-card",
      heading: "Why Nomad?",
      description: "Discover what makes Nomad Health the best place to grow your travel nurse or travel allied career.",
      image: {
        url: asset("/components/mega-menu/Why-Nomad.jpg")
      },
      link: {
        url: "/why-nomad"
      }
    }
  }
];
var NAV_DATA_default = NAV_DATA;

// src/mega-menu/HEADER_DATA.ts
var HEADER_DATA = {
  logo: {
    url: "/",
    alt: "Nomad Health"
  },
  login: {
    url: "/sign-in",
    label: "Login"
  },
  register: {
    url: "/register",
    label: "Join Us"
  },
  facilities: {
    url: "/facilities",
    label: "For Facilities"
  },
  nav: NAV_DATA_default
};
var HEADER_DATA_default = HEADER_DATA;
export {
  HEADER_DATA_default as HEADER_DATA,
  MegaMenu
};
